export default __webpack_public_path__ + "static/media/logo.d02daa61.svg";